import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from './App/Components';
import { MuiThemeProvider } from 'src/core/MuiThemeProvider';
import { StoreProvider } from 'src/core/StoreProvier';
import { Routes } from 'src/App/Routes';
import { useCacheBuster } from 'src/core/CacheBuster';
import ErrorLog from './core/ErrorLog';

const App = () => {
  const { loading, isLatestVersion, refreshCacheAndReload } = useCacheBuster();

  const isLocalHost = window.location.hostname === 'localhost';

  useEffect(() => {
    if (!loading && !isLatestVersion) {
      refreshCacheAndReload();
    }
  }, [loading, isLatestVersion]);

  return (
    <BrowserRouter>
      <StoreProvider>
        <MuiThemeProvider>
          <ErrorBoundary>
            <ErrorLog isTest={isLocalHost}>
              <Routes />
            </ErrorLog>
          </ErrorBoundary>
        </MuiThemeProvider>
      </StoreProvider>
    </BrowserRouter>
  );
};

export default App;
